<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f008-01.jpg" width="80%"/></p>
<p class="caption">The west tower of St Mary Magdalene’s church, Campsall is the finest surviving example of Norman architecture in South Yorkshire. It replaced an earlier Norman cruciform tower.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_chapter017.vue?a7576508